import { Formik } from "formik";
import { FC, createContext } from "react";
import TableLogPatient from "./components/TablePatientLog";

export interface LogPatientPageContextProps {}

interface IProps {}

const initialContext = {};

export const LogPatientPageContext =
  createContext<LogPatientPageContextProps>(initialContext);

export const LogPatientPage: FC<IProps> = (props) => {
  return (
    <Formik<any> initialValues={{}} onSubmit={() => {}}>
      <LogPatientPageContext.Provider value={{}}>
        <div className="bg-white">
          <div className="flex-1 flex flex-column">
            <div className="py-1 ">
              <TableLogPatient />
            </div>
          </div>
        </div>
      </LogPatientPageContext.Provider>
    </Formik>
  );
};

export default LogPatientPage;
